export interface WishlistActivationEvent {
	id: string;
	type: WishlistActivationBenefitType;
	active: boolean;
	eventMergeId?: string;
}

export enum WishlistActivationBenefitType {
	PARTNER = "partner",
	PLATFORM = "platform",
}
